var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAdminShort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.163 20.0034C39.163 8.95037 30.4151 0 19.6187 0H19.5376C8.74797 0 0 8.95037 0 20.0034C0 27.1347 2.94754 30.6899 5.96944 30.6C6.09113 30.6 6.20605 30.6 6.32774 30.5793C8.21389 30.3856 10.4043 28.5111 10.4043 24.2988V19.0005C10.4043 13.8129 14.5146 9.60746 19.5781 9.60746C24.6417 9.60746 28.752 13.8129 28.752 19.0005V25.3363C28.752 26.8926 27.5216 28.1515 26.0005 28.1515C24.4794 28.1515 23.249 26.8926 23.249 25.3363V19.0005C23.249 16.9462 21.6198 15.2793 19.6119 15.2793H19.5308C17.523 15.2793 15.9005 16.9462 15.8937 19.0005V24.2988C15.8937 27.522 15.0013 30.3579 13.3248 32.516C11.9524 34.2936 10.046 35.5386 7.89616 36.0643C11.2628 38.6235 15.3394 40.0069 19.5308 40H19.6119C30.4151 40 39.163 31.0427 39.163 20.0034Z",
    fill: "#094C79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAdminShort);
export default __webpack_public_path__ + "static/media/logo-admin-short.8165ed12e2d457a1f063800b760bd9a4.svg";
export { ForwardRef as ReactComponent };